import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { ClosePopupImage, PopupText, PopupTopSection } from './styled';

const PopupTopStrip = (props) => {
  const { closePopup } = props;
  return (
    <PopupTopSection>
      <ClosePopupImage
        onClick={() => closePopup()}
        src={images.plusBlack}
      ></ClosePopupImage>
      <PopupText>Select Size</PopupText>
    </PopupTopSection>
  );
};

export default PopupTopStrip;
